import { useCurrentUser } from "../../../hooks/useCurrentUser";
import React, { useState, useEffect, useRef } from "react";
import { Offcanvas, OffcanvasBody } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IoIosArrowBack } from "react-icons/io";
import { DatePicker } from "@mui/x-date-pickers";
// import { useDispatch } from "react-redux";
import "../../../App.css";
import { Autocomplete, FormControl, FormControlLabel, Menu, MenuItem, Modal, Radio, RadioGroup, Select, TextField,} from "@mui/material";
import { useTheme } from "../../../ThemeContext";
import { ExpandMore } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {DataGrid,} from "@mui/x-data-grid";
import { CiExport, CiViewList } from "react-icons/ci";
import { Box, Checkbox, IconButton, Typography, Avatar, Tooltip } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate, useParams } from "react-router-dom";
import { addData, newFilterEntities, postdatas,postResource,} from "../../../apis/apiService";
import { format } from "date-fns";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import ReactQuill from "react-quill-new";
import { useSelector } from "react-redux";
import { useFetchLogDetailsQuery,} from "../../../slice/logdetailSlice";
import CommonDeleteDialog from "../../common/CommonDelete";
import { CommonExportComponent } from "../../common/CommonTimesheetExport";
import { CommonAddLogHours } from "../../common/CommonAddLogHour";
import { openInNewTab } from "../../../utils/openInNewTab";

export const ValidDailyLog = (time) => {
  const [hours, minutes] = time.split(":");
  const formattedHours = hours.padStart(2, "0");
  const formattedMinutes = minutes.padStart(2, "0");
  if (hours < 0 || hours > 23) {
    // console.error("Hours must be less than or equal to 23.");
    // toast.error("Hours must be greter than 0 and less than  23");
    toast.error("Hours must be between 0 and 23.");
    return;
  }
  if (minutes < 0 || minutes > 59) {
    toast.error("Minutes must be between 0 and 59.");
    return;
  }
  if (formattedMinutes > 59) {
    // console.error("Minutes must be less than or equal to 59.");
    toast.error("Minutes must be less than or equal to 59.");
    return false;
  }
  if (formattedHours === "00" && formattedMinutes === "00") {
    toast.error("00:00 is not a valid time.");
    return;
  }

  return `${formattedHours}:${formattedMinutes}`;
};

const AddSubTaskLogHoursComponent = ({ onApply, onClear, onCancel }) => {
  const hourOptions = Array.from({ length: 12 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );
  const [selectedHour, setSelectedHour] = useState(hourOptions[0]);
  const [selectedEndHour, setSelectedEndHour] = useState(hourOptions[0]);

  const minutesOptions = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, "0")
  );

  const [selectedMinutes, setSelectedMinutes] = useState(minutesOptions[0]);
  const [selectedEndMinute, setSelectedEndMinute] = useState(minutesOptions[0]);
  const amPmOptions = ["AM", "PM"];
  const [showDailyLog, setShowDailyLog] = useState(false);
  const [selectedAmPm, setSelectedAmPm] = useState(amPmOptions[0]);
  const [selectedEndAmPm, setSelectedEndAmPm] = useState(amPmOptions[0]);
  const [fullTimeLog, setFullTimeLog] = useState("");
  const dateInputRef = useRef(null);
  const radioRef = useRef(null);
  const fullTimeRef = useRef(null);
  const currentDate = dayjs();
  const { id } = useParams();
  // //console.log()("add log hours id", id);
  const billing_type = localStorage.getItem("billing_type");
  const { name: loginUserName, id: loginUserId } = useCurrentUser();
  const [loading, setLoading] = useState(false);
  // //console.log()(
  //   "login_user_id id",
  //   loginUserId,
  //   " login_user_id username :",
  //   loginUserName
  // );
  const ownerNames = useSelector(
    (state) => state.selectOptions.ownerNameOptions
  );

  const { handleSubmit, control } = useForm({
    defaultValues: {
      date: currentDate,
      owner: loginUserId,
      billingType: "",
      Notes: "",
      startHour: "",
      startMinutes: "",
      startAmPm: "",
      endHour: "",
      endMinutes: "",
      fullTimeLog: "",
      endAmPm: null,
    },
  });

  const formatTime = (hour, minute, amPm) => {
    if (!hour || !minute || !amPm) return null;
    const isPM = amPm === "PM";
    const formattedHour = isPM
      ? hour === "12"
        ? "12"
        : String(Number(hour) + 12).padStart(2, "0")
      : hour === "12"
        ? "00"
        : hour.padStart(2, "0");
    return `${formattedHour}:${minute}`;
  };

  const startTime = formatTime(selectedHour, selectedMinutes, selectedAmPm);
  const endTime = formatTime(
    selectedEndHour,
    selectedEndMinute,
    selectedEndAmPm
  );

  // //console.log()("Formatted Start Time:", startTime);
  // //console.log()("Formatted End Time:", endTime);
  const { data, isLoading, error, refetch } = useFetchLogDetailsQuery(id);
  const onSubmit = async (data) => {
    // //console.log()("Form Data:", data);

    const startTime = formatTime(selectedHour, selectedMinutes, selectedAmPm);
    const endTime = formatTime(
      selectedEndHour,
      selectedEndMinute,
      selectedEndAmPm
    );
    // if (!showDailyLog) {
    //   // Check if start time and end time are equal
    //   if (startTime === endTime) {
    //     console.error("Start time or end time is missing or invalid.");
    //     toast.error("Start time and end time cannot be the same.");
    //     return;
    //   }
    // }
    if (!showDailyLog) {
      if (!selectedHour || !selectedMinutes || !selectedAmPm ||
        !selectedEndHour || !selectedEndMinute || !selectedEndAmPm) {
        toast.error("Please select both start and end time.");
        return;
      }

      if (startTime === endTime) {
        toast.error("Start time and end time cannot be the same.");
        return;
      }
    }

    setLoading(true);

    // Define payload based on the value of showDailyLog
    const payload = {
      log_date: data.date ? dayjs(data.date).format("YYYY-MM-DD") : null,
      notes: data.Notes,
      owner_id: loginUserId,
      billing_type: billing_type,
      // task_id: id,
    };

    // If showDailyLog is true, send fullTimeLog, else send start_time and end_time
    if (showDailyLog) {
      payload.hours_in_text = ValidDailyLog(fullTimeLog); // Send full time if showDailyLog is true
    } else {
      payload.start_time = startTime; // Send start time if showDailyLog is false
      payload.end_time = endTime; // Send end time if showDailyLog is false
    }

    // //console.log()("Payload to API:", payload);
    // //console.log()("Full time:", fullTimeLog);

    try {
      const response = await addData("task/timelog", id, payload);
      // //console.log()("API Response:", response);
      onApply(payload);
      if (response) {
        toast.success(response.message);
        refetch();
        // //console.log()("items :", data);
      }
    } catch (error) {
      console.error("Error adding subtask log hours:", error);
    } finally {
      setLoading(false);
    }
  };

  // auto complete with hours

  return (
    <div className="">
      <div className="d-flex align-i tems-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex align-items-center">
            <IoIosArrowBack />
            Add Time Log
          </div>
        </button>
      </div>
      <div className="bg-white px-4 py-3 ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row mb-3">
                <div className="col-md-6 mb-3">
                  <label htmlFor="date" className="form-label">
                    Date <span className="errorMsg">*</span>
                  </label>
                  <div className=" d-flex flex-column w-100">
                    <Controller
                      name="date"
                      defaultValue={currentDate}
                      control={control}
                      // rules={{ required: "Date is required" }}
                      render={({ field }) => {
                        return (
                          <>
                            <DatePicker
                              {...field}
                              inputRef={dateInputRef} // Attach ref to DatePicker
                              format="DD/MM/YYYY"
                              onChange={(date) => field.onChange(date)}
                              value={field.value || currentDate}
                              renderInput={(params) => (
                                <input className="form-control" {...params} />
                              )}
                            />
                            {/* {error && <p className="errorMsg">{error.message}</p>} */}
                          </>
                        );
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="owner" className="form-label">
                    Owner <span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="owner"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          labelId="owner-label"
                          id="owner"
                          {...field}
                          IconComponent={ExpandMore}
                          value={loginUserId}
                        >
                          <MenuItem value={loginUserId}>
                            {loginUserName}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="billingType" className="form-label">
                    Billing Type <span className="errorMsg">*</span>
                  </label>
                  <RadioGroup row value={billing_type}>
                        <FormControlLabel
                          value="BILLABLE"
                      control={<Radio disabled />}
                          checked={billing_type === "BILLABLE"}
                          label="BILLABLE"
                          inputRef={radioRef}
                        />
                        <FormControlLabel
                          value="NON-BILLABLE"
                      control={<Radio disabled />}
                          checked={billing_type === "NON-BILLABLE"}
                          label="NON-BILLABLE"
                        />
                  </RadioGroup>
                </div>
                {/* <DailyLog /> */}
                {showDailyLog && (
                  <div className="col-md-6">
                    <label htmlFor="fullTimeLog" className="form-label">
                      Daily Log <span className="errorMsg">*</span>
                    </label>
                    <Controller
                      name="fullTimeLog"
                      control={control}
                      rules={{
                        required: "Daily log hours feild is required ",
                      }}
                      defaultValue="0:00"
                      render={({ field, fieldState: { error } }) => {
                        if (error && fullTimeRef.current) {
                          fullTimeRef.current.focus();
                        }
                        return (
                          <>
                            <TextField
                              {...field}
                              variant="outlined"
                              inputProps={{ pattern: "^\\d{1,2}:\\d{2}$" }}
                              fullWidth
                              placeholder="HH:MM"
                              ref={fullTimeRef}
                              onChange={(e) => {
                                field.onChange(e);
                                // //console.log()(e.target.value);
                                setFullTimeLog(e.target.value);
                              }}
                            />
                            {error && (
                              <p className="errorMsg">{error.message}</p>
                            )}
                          </>
                        );
                      }}
                    />
                  </div>
                )}
                {!showDailyLog && (
                  <div className="col-md-12 mt-1">
                    <label htmlFor="fullTimeLog" className="form-label">
                      Daily Log <span className="errorMsg">*</span>
                    </label>
                    <div className="row">
                      <div className="col-6">
                        <span className="lightText">From</span>
                        <div className="row">
                          <div className="col-12 col-lg-4">
                            <div className="autoCompleteTime">
                              <Autocomplete
                                options={hourOptions}
                                value={selectedHour}
                                onChange={(event, newValue) =>
                                  setSelectedHour(newValue)
                                }
                                disableClearable
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    name="startHour"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: "36px",
                                      },
                                      "& input": { padding: "8px" },
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-lg-4">
                            <div className="autoCompleteTime">
                              <Autocomplete
                                options={minutesOptions}
                                value={selectedMinutes}
                                onChange={(event, newValue) =>
                                  setSelectedMinutes(newValue)
                                }
                                disableClearable
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    name="startMinute"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: "36px",
                                      },
                                      "& input": { padding: "8px" },
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-lg-4">
                            <div className="autoCompleteTime">
                              <Autocomplete
                                options={amPmOptions}
                                value={selectedAmPm}
                                disableClearable
                                onChange={(event, val) => setSelectedAmPm(val)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    name="startAmPm"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: "36px",
                                      },
                                      "& input": { padding: "8px" },
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <span className="lightText">To</span>
                        <div className="row">
                          <div className="col-12 col-lg-4">
                            {/* <label className="form-label">To</label> */}
                            <div className="autoCompleteTime">
                              <Autocomplete
                                options={hourOptions}
                                value={selectedEndHour}
                                disableClearable
                                onChange={(event, val) =>
                                  setSelectedEndHour(val)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    name="endHour"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: "36px",
                                      },
                                      "& input": { padding: "8px" },
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-lg-4">
                            <div className="autoCompleteTime">
                              <Autocomplete
                                options={minutesOptions}
                                value={selectedEndMinute}
                                disableClearable
                                onChange={(event, newValue) =>
                                  setSelectedEndMinute(newValue)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    name="endMinutes"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: "36px",
                                      },
                                      "& input": { padding: "8px" },
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-lg-4">
                            <div className="autoCompleteTime">
                              <Autocomplete
                                options={amPmOptions}
                                value={selectedEndAmPm}
                                disableClearable
                                onChange={(event, val) =>
                                  setSelectedEndAmPm(val)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    name="endAmPm"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: "36px",
                                      },
                                      "& input": { padding: "8px" },
                                    }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* enter  hours */}
                <div className="col-md-4">
                  <p
                    className="enterHourse"
                    onClick={() => setShowDailyLog(!showDailyLog)}
                  >
                    {!showDailyLog ? "enter hours" : "set start & end time"}
                  </p>
                </div>
                <div className="col-md-12 paddingBtn   ">
                  <label htmlFor="">
                    Notes<span className="errorMsg">*</span>
                  </label>
                  <Controller
                    name="Notes"
                    control={control}
                    rules={{
                      required: "Notes field is required", // Add validation rule
                    }}
                    render={({
                      field: { ref, onChange, value },
                      fieldState: { error },
                    }) => (
                      <div>
                        <ReactQuill
                          theme="snow"
                          onChange={onChange}
                          value={value}
                        />
                        {error && <p className="errorMsg">{error.message}</p>}
                      </div>
                    )}
                  />
                </div>
              </div>

              <div className="bg-white position-absolute bottom-0 py-3 w-100">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={loading}
                  >
                    {loading ? "Adding...." : "Add"}
                  </button>

                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

// Function to transform the data into the desired format
const transformFilteredData = (data) => {
  // Group the data by log_date
  const groupedData = data.reduce((acc, item) => {
    const logDate = item.log_date;

    if (!acc[logDate]) {
      acc[logDate] = {
        log_date: logDate,
        total_hours: 0,
        billable_hours: 0,
        non_billable_hours: 0,
        time_logs: [],
      };
    }

    // Update the grouped log totals
    acc[logDate].total_hours += item.hours;
    acc[logDate].billable_hours +=
      item.billing_type === "BILLABLE" ? item.hours : 0;
    acc[logDate].non_billable_hours +=
      item.billing_type === "NON-BILLABLE" ? item.hours : 0;

    // Add the individual time log
    acc[logDate].time_logs.push({
      time_logs_id: item.time_logs_id,
      log_type: item.log_type,
      start_time: item.start_time,
      end_time: item.end_time,
      hours_in_text: item.hours_in_text,
      hours: item.hours,
      billing_type: item.billing_type,
      notes: item.notes, // Remove HTML tags from notes
      owner_name: item.owner_name,
      added_name: item.added_name,
      updated_name: item.updated_name || null,
      project_title: item.project_title,
      log_date: item.log_date,
    });

    return acc;
  }, {});

  // Convert the grouped object into an array
  return Object.values(groupedData);
};

// Fetching data from sessionStorage and transforming it

const FilterTaskLogHoursComponent = ({ onApply, onClear, onCancel }) => {
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      owner: "",
      start_date: null,
      end_date: null,
      billingType: "",
      createdBy: "",
    },
  });

  const [filteredData, setFilteredData] = useState([]);
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  // //console.log()("filter log hours id", id);
  const onSubmit = async (data) => {
    // //console.log()(data);
    setLoading(true);
    const filterLogData = {
      owner_id: data.owner,
      added_by: data.createdBy,
      start_date: data.start_date
        ? format(new Date(data.start_date), "yyyy-MM-dd")
        : null,
      end_date: data.end_date
        ? format(new Date(data.end_date), "yyyy-MM-dd")
        : null,
      billing_type: data.billingType,
    };

    try {
      const response = await newFilterEntities(
        "task/timelog/filter",
        id,
        filterLogData
      );

      // //console.log()("Task_filter_log_hours:", response);
      if (response.session_data) {
        // //console.log()("filter entries:", response.session_data);
        const { key, value } = response.session_data;
        // //console.log()("filter_session_data ", {
        //   key: key,
        //   value: value,
        // });

        sessionStorage.setItem(key, JSON.stringify(value));
      }

      if (response) {
        onApply(response); // Assuming response contains the data needed for onApply
        setFilteredData(response); // Update state with filtered data
        // storeFilteredResponse(response);
        toast.success(response.message || "Filter applied successfully!");
      } else {
        // Handle the case where response is falsy
        toast.error("No data received from the filter. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching task time logs:", error);
      const errorMsg = error.message;
      toast.error(errorMsg || "Failed to apply filter");
    } finally {
      setLoading(false);
    }
  };
  const usersList = useSelector(
    (state) => state.selectOptions?.userNamesByProjects
  );
  // //console.log()("user_list :", usersList);

  const handleClear = () => {
    reset(); // Reset the form to default values
    setFilteredData([]);
    onClear?.(); // Trigger any additional clear action if provided
  };

  return (
    <div>
      {/* Header Section */}
      <div className="d-flex align-items-center justify-content-between px-4 py-3 bg-white">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex align-items-center">
            <IoIosArrowBack />
            Filter
          </div>
        </button>
        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red"
          >
            Clear Filter
          </button>
        </div>
      </div>

      {/* Filter Form */}
      <div className="px-4 py-3 bg-white">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-3">
              {/* Row 1 */}
              <div className="col-md-12">
                <label htmlFor="owner" className="form-label">
                  Owner
                </label>

                <Controller
                  name="owner"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <Select
                        labelId="owner-label"
                        id="owner"
                        IconComponent={ExpandMore}
                        {...field}
                        displayEmpty
                        renderValue={(selected) =>
                          selected ? (
                            usersList.find((list) => list.user_id === selected)
                              ?.name
                          ) : (
                            <span className=" lightText ">
                              Select user name
                            </span>
                          )
                        }
                      >
                        {usersList.map((ownerName, index) => (
                          <MenuItem key={index} value={ownerName.user_id}>
                            {ownerName.name}
                          </MenuItem>
                        ))}

                        {/* Add other options as needed */}
                      </Select>
                    </FormControl>
                  )}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Start Date</label>
                <Controller
                  name="start_date"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      onChange={(date) => field.onChange(date)}
                      renderInput={(params) => (
                        <TextField {...params} className="form-control" />
                      )}
                    />
                  )}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">End Date</label>
                <Controller
                  name="end_date"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      onChange={(date) => field.onChange(date)}
                      renderInput={(params) => (
                        <TextField {...params} className="form-control" />
                      )}
                    />
                  )}
                />
              </div>

              {/* Row 2 */}
            </div>
            <div className="row paddingBtn mt-3 ">
              <div className="col-md-6">
                <label className="form-label">Billing Type</label>
                <Controller
                  name="billingType"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <Select
                        {...field}
                        displayEmpty
                        renderValue={(selected) =>
                          selected ? (
                            selected
                          ) : (
                            <span className="  lightText  ">Select type</span>
                          )
                        }
                      >
                        <MenuItem value="BILLABLE">BILLABLE</MenuItem>
                        <MenuItem value="NON-BILLABLE">NON-BILLABLE</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </div>

              {/* Row 3 */}
              <div className="col-md-6 ">
                <label className="form-label">Created By</label>
                <Controller
                  name="createdBy"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <Select
                        {...field}
                        labelId="createdBy-label"
                        id="createdBy"
                        {...control.register("createdBy")}
                        displayEmpty
                        renderValue={(selected) =>
                          selected ? (
                            usersList.find((user) => user.user_id === selected)
                              ?.name
                          ) : (
                            <span className="lightText">Select user</span>
                          )
                        }
                        IconComponent={ExpandMore} // Add the custom icon here
                      >
                        {usersList.map((user, index) => (
                          <MenuItem key={index} value={user.user_id}>
                            {user.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
              </div>
            </div>
            {/* Footer Buttons */}
            <div className="bg-white position-absolute bottom-0 py-3 w-100">
              <div className="d-flex justify-content-left mt-3">
                <button
                  type="submit"
                  className="me-3 add_btn"
                  disabled={loading}
                >
                  {loading ? "Applying..." : "Apply"}
                </button>

                <button type="button" className="cancel_btn" onClick={onCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};
const ExportComponent = ({ onApply, onClear, onCancel }) => {
  const { id } = useParams();
  const radioRef = useRef();
  const [filteredResponse, setFilteredResponse] = useState([]);
  // //console.log()("useparams id : ", id);

  useEffect(() => {
    const sessionData = sessionStorage.getItem("filtered_timesheets");
    if (sessionData) {
      const parsedData = JSON.parse(sessionData);
      const formattedData = transformFilteredData(parsedData);
      // //console.log()("filtered parse data:", formattedData);
      setFilteredResponse(formattedData); // This will not cause an infinite loop
      // //console.log()("Transformed Data:", formattedData);
    } else {
      // //console.log()("No data found in session storage.");
    }
  }, []); // Empty dependency array ensures this only runs once

  const timesheetViewOptions = useSelector(
    (state) => state.selectOptions?.timesheetViewOptions || {}
  );

  const timesheetViewOptionsArray = Object.entries(timesheetViewOptions).map(
    ([key, value]) => ({
      title: value, // Display value in the dropdown
      value: key, // Key as the unique identifier
    })
  );

  // //console.log()(
  //   "Transformed timesheetViewOptionsArray:",
  //   timesheetViewOptionsArray
  // );
  const usersInproject = useSelector(
    (state) => state.selectOptions?.userNamesByProjects
  );
  // //console.log()("userNamesByProjects :", usersInproject);

  const [loading, setLoading] = useState(false);
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      Users: "",
      StartDate: null,
      EndDate: null,
      billingType: "",
      createdBy: "",
      exportData: "",
      timesheetView: "",
      format: "",
    },
  });
  const onSubmit = async (data) => {
    // //console.log()(data);
    const requestedData = {
      added_by: data.createdBy,
      billing_type: data.billingType,
      start_date: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      end_date: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
      columns: data.timesheetView,
      export_mode: data.exportData,
      format: data.format,
      filtered_data: filteredResponse,
    };
    setLoading(true);
    // //console.log()("filter requested data:", requestedData);

    try {
      const response = await postdatas("task/timelog", "export", requestedData);
      // //console.log()("doc_urls response :", response);

      if (response) {
        const doc_url = response.doc_url;
        // //console.log()("doc_urls : ", doc_url);

        const formattedDocUrl = doc_url.replace(/\\/g, "/"); // Replace backslashes
        // //console.log()("Formatted doc_urls:", formattedDocUrl);

        if (!formattedDocUrl) {
          throw new Error("Document URL not found");
        }

        // Open the file URL directly
        openInNewTab(formattedDocUrl);
        toast.success("Document downloaded successfully");
      } else {
        throw new Error("The response does not contain a valid doc_url.");
      }

      toast.success("Export successful.");
    } catch (error) {
      console.error("Error filtering tasks:", error.response.data.message);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }

    // try {
    //   const response = await postdatas("task/timelog", "export", requestedData);
    //   // //console.log()("doc_urls response:", response);

    //   if (response) {
    //     const doc_url = response.doc_url;
    //     // //console.log()("doc_urls : ", doc_url);

    //     const formattedDocUrl = doc_url.replace(/\\/g, "/"); // Replace backslashes
    //     // //console.log()("Formatted doc_urls:", formattedDocUrl);

    //     if (!formattedDocUrl) {
    //       throw new Error("Document URL not found");
    //     }

    //     // Fetch the PDF file as a Blob and force download
    //     const fileExtension = formattedDocUrl.split(".").pop(); // Get file extension
    //     // //console.log()("doc_urls extention : ", fileExtension);

    //     if (fileExtension === "pdf") {
    //       const pdfResponse = await fetch(formattedDocUrl);
    //       if (!pdfResponse.ok) {
    //         throw new Error("Failed to fetch the PDF file.");
    //       }
    //       const pdfBlob = await pdfResponse.blob();
    //       const pdfUrl = URL.createObjectURL(pdfBlob);

    //       const anchor = document.createElement("a");
    //       anchor.href = pdfUrl;
    //       anchor.download = "exported_file.pdf"; // Specify the download filename
    //       document.body.appendChild(anchor);
    //       anchor.click();
    //       document.body.removeChild(anchor);

    //       // Revoke the object URL to free memory
    //       URL.revokeObjectURL(pdfUrl);

    //       toast.success("PDF downloaded successfully");
    //     } else {
    //       // Open non-PDF files in a new tab
    //       window.open(formattedDocUrl, "_blank");
    //       toast.success("Document opened successfully");
    //     }
    //   } else {
    //     throw new Error("The response does not contain a valid doc_url.");
    //   }

    //   toast.success("Export successful.");
    // } catch (error) {
    //   console.error("Error filtering tasks:", error);
    //   toast.error(error.message || "An error occurred during export.");
    // }
  };

  const handleClear = () => {
    reset(); // Reset the form to default values
    onClear?.(); // Trigger any additional clear action if provided
  };

  return (
    <div>
      {/* Header Section */}
      <div className="d-flex align-items-center justify-content-between px-4 py-3 bg-white">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex align-items-center">
            <IoIosArrowBack />
            Export Timelog
          </div>
        </button>
        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red"
          >
            Clear Filter
          </button>
        </div>
      </div>

      {/* Filter Form */}
      <div className="px-4 py-3 bg-white">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-3">
              {/* Row 1 */}
              <div className="col-md-12 mt-3">
                <label htmlFor="Users" className="form-label">
                  Users
                </label>
                <Controller
                  name="Followers"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      multiple
                      id="Followers"
                      options={usersInproject}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.name}
                      value={
                        (value || []).map((user_id) =>
                          usersInproject.find(
                            (user) => user.user_id === user_id
                          )
                        ) || []
                      }
                      onChange={(event, newValue) => {
                        const selectedTitles = newValue.map(
                          (user) => user.user_id
                        );
                        onChange(selectedTitles);
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li
                          {...props}
                          className="d-flex align-items-center mb-2"
                        >
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          <strong>{option.name}</strong>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Users" />
                      )}
                      ListboxProps={{
                        style: {
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "8px",
                          paddingLeft: "0",
                        },
                      }}
                    />
                  )}
                />
                {/*  */}
              </div>

              {/* Row 2 */}
              <div className="col-md-6">
                <label htmlFor="StartDate">Start date</label>
                <Controller
                  name="StartDate"
                  control={control}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      onChange={(date) => field.onChange(date)}
                      renderInput={(params) => (
                        <TextField {...params} className="form-control" />
                      )}
                    />
                  )}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="EndDate">End date</label>
                <Controller
                  control={control}
                  name="EndDate"
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      onChange={(date) => field.onChange(date)}
                      renderInput={(params) => (
                        <TextField {...params} className="form-control" />
                      )}
                    />
                  )}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Billing Type</label>
                <Controller
                  name="billingType"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <Select
                        {...field}
                        displayEmpty
                        renderValue={(selected) =>
                          selected ? (
                            selected
                          ) : (
                            <span className=" lightText">Select type</span>
                          )
                        }
                      >
                        <MenuItem value="BILLABLE">Billable</MenuItem>
                        <MenuItem value="NON-BILLABLE">Non-Billable</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
              </div>

              {/* Row 3 */}

              <div className="col-md-6">
                <label className="form-label">Created By</label>
                <Controller
                  name="createdBy"
                  control={control}
                  render={({ field }) => (
                    <FormControl fullWidth>
                      <Select
                        {...field}
                        displayEmpty
                        renderValue={(selected) =>
                          selected ? (
                            usersInproject.find(
                              (user) => user.user_id === selected
                            )?.name
                          ) : (
                            <span className=" lightText">Select user</span>
                          )
                        }
                      >
                        {usersInproject.map((user, index) => (
                          <MenuItem key={index} value={user.user_id}>
                            {user.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
              </div>

              <div className="col-md-12 mt-3">
                <label htmlFor="timesheetView" className="form-label">
                  Timesheet View <span className="errorMsg">*</span>
                </label>

                <Controller
                  name="timesheetView"
                  control={control}
                  rules={{ required: "Export column field is required" }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <>
                      <Autocomplete
                        multiple
                        id="timesheetView"
                        options={timesheetViewOptionsArray}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.title || ""}
                        value={
                          Array.isArray(value)
                            ? value.map((val) =>
                              timesheetViewOptionsArray.find(
                                (item) => item.value === val
                              )
                            )
                            : []
                        }
                        onChange={(event, newValue) => {
                          const selectedTitles = newValue.map(
                            (item) => item.value
                          );
                          onChange(selectedTitles);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.title}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Timesheet View" />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                      {error && (
                        <span className="errorMsg">{error.message}</span>
                      )}
                    </>
                  )}
                />
              </div>

              {/* Row 3 */}

              <div className="col-md-6">
                <label className="form-label">
                  Format <span className="errorMsg">*</span>
                </label>
                <Controller
                  name="format"
                  rules={{ required: "Format field is required" }}
                  control={control}
                  render={({
                    field: { ref, onChange, value },
                    fieldState: { error },
                  }) => (
                    <FormControl fullWidth>
                      <Select
                        // {...field}
                        inputRef={ref}
                        onChange={(e) => onChange(e)}
                        value={value}
                        displayEmpty
                        renderValue={(selected) =>
                          selected ? (
                            selected
                          ) : (
                            <span className=" lightText">Format</span>
                          )
                        }
                      >
                        <MenuItem value="excel">excel</MenuItem>
                        <MenuItem value="pdf">pdf</MenuItem>
                      </Select>
                      {error && (
                        <span className="errorMsg">{error.message}</span>
                      )}
                    </FormControl>
                  )}
                />
              </div>
            </div>
            <div className="row paddingBtn mt-3">
              <div className="col-md-12 ">
                {/* <label htmlFor="">
                  Export along with the current filter section
                  <span className="errorMsg">*</span>
                </label> */}
                <Controller
                  name="exportData"
                  control={control}
                  rules={{ required: "Export Type field is required" }}
                  render={({ field, fieldState: { error } }) => {
                    if (error && radioRef.current) {
                      radioRef.current.focus();
                    }

                    return (
                      <div>
                        <RadioGroup row {...field}>
                          <FormControlLabel
                            value="current_filter"
                            control={<Radio />}
                            label="Export along with the current filter section"
                            ref={radioRef} // Attaching ref to the first radio button
                          />
                          <FormControlLabel
                            value="default"
                            control={<Radio />}
                            label="Export default data"
                          />
                        </RadioGroup>
                        {error && <p className="errorMsg">{error.message}</p>}
                      </div>
                    );
                  }}
                />
              </div>
            </div>
            {/* Footer Buttons */}
            <div className="d-flex   position-absolute bottom-0 bg-white w-100 py-3    mt-5">
              <button type="submit" className="add_btn me-3">
                {loading ? "Applying..." : "Apply"}
              </button>
              <button type="button" className="cancel_btn" onClick={onCancel}>
                Cancel
              </button>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

// const TaskLogHours = () => {
  const TaskLogHours = ({ parentRefetch }) => {
  const { isDarkMode } = useTheme();
  const [expandedRows, setExpandedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [projects, setProjects] = useState([]);
  const handleShowFilter = () => setShowFilter(true);
  const [showFilter, setShowFilter] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [showQuillPopup, setShowQuillPopup] = useState(false);
  const [quillContent, setQuillContent] = useState("");
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [showExportPage, setShowExportPage] = useState(false);
  const [checkedRows, setCheckedRows] = useState({});
  const { id } = useParams();
  const navigate = useNavigate();
  const fromDate = dayjs().format("YYYY-MM-DD");
  const toDate = dayjs().format("YYYY-MM-DD");

  // //console.log()("show log hours id", id);
  const [updatedSubtask, setUpdatedSubtask] = useState({
    // Set initial state values if required
    start_time: "",
    end_time: "",
    Date: null, // or other fields as needed
    logHourse: 0,
    dashBoard: "",
    // Add other fields if necessary
  });
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // //console.log()("login_user in task:", login_user);
  const { role: login_user_role } = login_user;
  // //console.log()("login_user role in task:", login_user_role);
  const handleDashboardSave = async () => {
    // Update the row data
    const updatedSubtask = data
      .find((project) =>
        project.subtasks.some((subtask) => subtask.id === selectedRowId)
      )
      .subtasks.find((subtask) => subtask.id === selectedRowId);

    const updatedRow = { ...updatedSubtask, dashBoard: quillContent };

    // Save to the database
    await handleSubtaskUpdate(updatedRow);

    // Update the local state
    const updatedProjects = data.map((project) => {
      // Create a deep copy of each project
      return {
        ...project,
        subtasks: project.subtasks.map((subtask) => {
          if (subtask.id === selectedRowId) {
            return { ...subtask, dashBoard: quillContent }; // Create a new subtask object
          }
          return subtask; // Return the original subtask
        }),
      };
    });

    setProjects(updatedProjects); // Update state with the new array

    // Close the popup
    setShowQuillPopup(false);
  };

  const convertTo12HourFormat = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const convertedHours = hours % 12 || 12; // Convert 0 or 12 to 12 for AM/PM format
    return `${convertedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  const { data, refetch } = useFetchLogDetailsQuery(id);
  // //console.log()("get flated show  data :", data);

  const [showProject, setShowProject] = useState(false);
  const { reset } = useForm();

  const handleShowProject = () => setShowProject(true);
  const toggleExpandRow = (rowId) => {
    setExpandedRows((prevExpandedRows) => {
      // If the clicked row is already expanded, collapse it
      if (prevExpandedRows[rowId]) {
        return { ...prevExpandedRows, [rowId]: false };
      }
      // Otherwise, close all other rows and expand the clicked one
      return { [rowId]: true };
    });
  };

  // const handleMenuOpen = (event, rowId) => {
  //   if (checkedRows[rowId]) {
  //     // //console.log()("task_response_menu_open :", rowId);
  //     // Open menu only if checkbox is checked
  //     setMenuAnchorEl(event.currentTarget);
  //     setSelectedRowId(rowId);
  //     setSelectedTask(rowId);
  //   }
  // };

  const handleMenuOpen = (event, task) => {
    setMenuAnchorEl(event.currentTarget);
    // //console.log()("task_response_menu_open :", task);
    const taskName = task.user || task.other_log_entries || "Unknown Task";
    setSelectedTask({ id: task.id, name: taskName, project_id: task.parentId });
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
    // setSelectedRowId(null);
  };

  const handleCheckboxChange = (rowId) => {
    setCheckedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId], // Toggle checkbox state
    }));
  };

  const handleViewDetail = (action) => {
    // //console.log()(`${action} task: ${selectedTask}`);
    navigate( `/projects/projectDetail/${id}/timesheet/TimeSheetDetail/${selectedTask?.id}`);
    handleMenuClose();
  };

  const handleViewDetailNewPage = () => {
    // //console.log()("view detail new page");

    const path = `/projects/projectDetail/${id}/timesheet/TimeSheetDetail/${selectedTask?.id}`;
    // navigate(path, "_blank");
    openInNewTab(path);
    handleMenuClose();
  };

  const getFlattenedRows = () => {
    const flattenedRows = [];

    if (filteredRows.length > 0) {
      filteredRows &&
        filteredRows.forEach((row) => {
          flattenedRows.push(row);
          if (expandedRows[row.id] && Array.isArray(row.subtasks)) {
            row.subtasks.forEach((subtask) => {
              flattenedRows.push({ ...subtask });
            });
          }
        });
    } 
    else {
      data &&
        data.forEach((row) => {
          flattenedRows.push(row);
          if (expandedRows[row.id] && Array.isArray(row.subtasks)) {
            row.subtasks.forEach((subtask) => {
              flattenedRows.push({ ...subtask });
            });
          }
        });
    }
    // filteredRows.length > 0
    //   ? // //console.log()("get flated rows filter here :", filteredRows)
    //   : // //console.log()("get flated rows filter not  :", flattenedRows);

    return flattenedRows;
  };

  const handleRowEdit = (newRow) => {
    if (!newRow.isSubtask) {
      toast.error("Only subtasks can be edited.");
      return;
    }

    // //console.log()("Edited Subtask:", newRow);

    // Trigger API update
    handleSubtaskUpdate(newRow);

    // Update the state with the new data
    const updatedProjects = [...projects];
    const parentIndex = updatedProjects.findIndex(
      (project) => project.id === newRow.parentId
    );

    if (parentIndex !== -1) {
      const subtaskIndex = updatedProjects[parentIndex].subtasks.findIndex(
        (subtask) => subtask.id === newRow.id
      );

      if (subtaskIndex !== -1) {
        const updatedSubtask = {
          ...updatedProjects[parentIndex].subtasks[subtaskIndex],
          ...newRow,
          timePeriod:
            newRow.start_time && newRow.end_time
              ? `${convertTo12HourFormat(
                newRow.start_time
              )} - ${convertTo12HourFormat(newRow.end_time)}`
              : "",
        };
        // //console.log()("updatedSubtask value  :", updatedSubtask);
        // //console.log()(
        //   "updatedSubtask value  time period1:",
        //   updatedSubtask.timePeriod
        // );

        updatedProjects[parentIndex].subtasks[subtaskIndex] = updatedSubtask;
        setProjects(updatedProjects); // Update the local state
      }
    }
  };

  const handleClearFilter = () => {
    // Reset projects state to original (unfiltered) data
    // setProjects(originalProjects); // Assuming `originalProjects` stores the unfiltered data
    reset(); // Reset the filter form fields
  };

  const handleApplyFilter = (filteredData) => {
    // Transform the response data to match the required format
    const transformedRows = filteredData.time_logs.map((log, index) => ({
      id: index,
      Date: log.log_date,
      logHourse: [
        `${log.total_hours}:00`,
        `${log.billable_hours}:00`,
        `${log.non_billable_hours}:00`,
      ],
      timePeriod: "",
      dashBoard: "",
      isTask: true,
      subtasks: Array.isArray(log.time_logs)
        ? log.time_logs.map((timeLog, subIndex) => {
          const text = timeLog.notes;
          const clearNotes = document.createElement("div");
          clearNotes.innerHTML = text;
          const textNotes = clearNotes.innerText.trim();
          const timePeriod =
            timeLog.start_time == null || timeLog.end_time == null
              ? ""
              : `${convertTo12HourFormat(
                timeLog.start_time
              )} - ${convertTo12HourFormat(timeLog.end_time)}`;

          return {
            id: timeLog.time_logs_id, // Include unique id
            timeLogId: timeLog.time_logs_id, // Include time_logs_id
            user: timeLog.added_name,
            logHourse: timeLog.hours_in_text,
            Date: log.log_date,
            timePeriod: timePeriod,
            dashBoard: textNotes,
            start_time: timeLog.start_time, // Add start_time
            end_time: timeLog.end_time, // Add end_time
            billingType: timeLog.billing_type,
            added_name: timeLog.added_name,
            isSubtask: true,
            parentId: index, // This will reference the parent task index
          };
        })
        : [],
    }));

    // Set the transformed rows to the state
    setFilteredRows(transformedRows);
    setShowFilter(false);
    // //console.log()(" get flated Original Filtered Data:", filteredData.time_logs);
    // //console.log()(" get flated Original Filtered rows response :", filteredRows);
    // //console.log()(" get flated Transformed Filtered Rows:", transformedRows);
  };

  // useEffect(() => {
  //   // //console.log()("hadleapply filter :", filteredRows);
  //   handleApplyFilter();
  // }, [filteredRows]);
  useEffect(() => {
    // //console.log()("get flated in state:", filteredRows); // Log whenever state updates
  }, [filteredRows]);
  // Function to format time to HH:mm (hours and minutes only)
  const formatTimeToHM = (time) => {
    if (!time) return "00:00"; // Default if no time is provided
    const [hours, minutes] = time.split(":").map(Number);
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`; // Format to HH:mm
  };

  const handleTimeChange = (field, value) => {
    setUpdatedSubtask({
      ...updatedSubtask,
      [field]: value,
    });
  };
  const formatTimeTo24Hour = (time) => {
    const isPM = time.toUpperCase().includes("PM");
    const isAM = time.toUpperCase().includes("AM");

    const [hours, minutes] = time
      .replace(/AM|PM/i, "") // Remove AM/PM
      .trim()
      .split(":")
      .map(Number);

    if (isNaN(hours) || isNaN(minutes)) {
      throw new Error(`Invalid time value: ${time}`);
    }

    let formattedHours = hours;
    if (isPM && hours !== 12) {
      formattedHours += 12; // Convert PM to 24-hour format
    } 
    else if (isAM && hours === 12) {
      formattedHours = 0; // Convert 12 AM to 0 (midnight)
    }

    return `${formattedHours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  const handleSubtaskUpdate = async (updatedSubtask) => {
    let startTime = null;
    let endTime = null;

    // Validate time format HH:mm

    // Validate date format and value
    const isValidDate = (date) =>
      /^\d{4}-\d{2}-\d{2}$/.test(date) && !isNaN(new Date(date).getTime());

    const isValidTimeFormat = (time) =>
      time === "24:00" || /^([01]\d|2[0-3]):([0-5]\d)$/.test(time);

    // Convert HH:mm to total minutes
    const timeToMinutes = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    };
    if (!updatedSubtask.logHourse) {
      toast.error("Time is required.");
      return;
    }
    // Validation
    if (updatedSubtask.logHourse) {
      const time = updatedSubtask.logHourse;

      // Check if it's parsable (roughly valid time-like format)
      if (!/^(\d{1,2}):([0-5]\d)$/.test(time)) {
        toast.error("Invalid time format. Use HH:mm .");
        return;
      }

      // Check if it's over 24:00
      if (timeToMinutes(time) > 1440) {
        toast.error("Log hours cannot exceed 24:00.");
        return;
      }

      // Now check actual allowed format (with 24:00 exception)
      if (!isValidTimeFormat(time)) {
        toast.error("Invalid time format. Use HH:mm .");
        return;
      }
    }
    if (!updatedSubtask.Date) {
      toast.error("Date is required.");
      return;
    }

    // Date validation
    if (updatedSubtask.Date && !isValidDate(updatedSubtask.Date)) {
      toast.error("Invalid date. Use YYYY-MM-DD.");
      return;
    }

    // Extract and convert start/end time if available
    if (updatedSubtask.timePeriod) {
      const [startTimeRaw, endTimeRaw] = updatedSubtask.timePeriod
        .split("-")
        .map((time) => time.trim());

      try {
        startTime = startTimeRaw ? formatTimeTo24Hour(startTimeRaw) : null;
        endTime = endTimeRaw ? formatTimeTo24Hour(endTimeRaw) : null;

        if (startTime === endTime) {
          toast.error("Start time and end time cannot be the same.");
          return;
        }
      } catch (err) {
        toast.error(err.message || "Invalid time format in timePeriod.");
        return;
      }
    }

    // Construct payload
    const postData = {
      log_date: updatedSubtask.Date,
      notes: updatedSubtask.dashBoard || "",
    };

    if (
      updatedSubtask.logHourse !== undefined &&
      updatedSubtask.logHourse !== null
    ) {
      postData.hours_in_text = updatedSubtask.logHourse;
    } else if (startTime && endTime) {
      postData.start_time = startTime;
      postData.end_time = endTime;
    }

    try {
      const response = await postResource(
        "task/timelog",
        "update",
        updatedSubtask.timeLogId,
        postData
      );

      toast.success(response.message);
      refetch();
      if (parentRefetch) {
        parentRefetch();
      }
    } 
    catch (err) {
      toast.error(err.message);
    }
  };

  const handleDashboardClick = (row) => {
    setSelectedRowId(row.id);
    setQuillContent(row.dashBoard || ""); // Load existing notes or empty
    setShowQuillPopup(true);
  };
  useEffect(() => {
    // showAllTimeLogEntities();
    refetch();
  }, [id]);

  const handleExportPage = () => {
    setShowExportPage(true);
  };

  const hadleExport = (exportData) => {
    setShowExportPage(false);
  };

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1}>
          {params.row.isTask && (
            <IconButton onClick={() => toggleExpandRow(params.row.id)}>
              {expandedRows[params.row.id] ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </IconButton>
          )}
          {params.row.isSubtask && (
            <Checkbox
              checked={!!checkedRows[params.row.id]} // Ensure boolean value
              onChange={() => handleCheckboxChange(params.row.id)}
            />
          )}
          <IconButton
            onClick={(event) => handleMenuOpen(event, params.row)}
            disabled={!checkedRows[params.row.id]} // Disable if checkbox is unchecked
          >
            <MoreVertIcon />
          </IconButton>
        </Box>
      ),
    },
    {
      field: "user",
      headerName: "Task",
      width: 240,
      editable: false, // The main task row doesn't need to be editable
      renderCell: (params) => {
        if (params.row.isTask) {
          // Display log_date for task rows
          return (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: "bold" }}>
                {login_user_role != "EMPLOYEE"
                  ? params.row.userName
                  : params.row.Date}
              </span>
            </Box>
          );
        } else if (params.row.isSubtask) {
          // Display the username for subtasks
          // if (!params.value) return "—"; // Default fallback for undefined usernames
          const initials = params.value
            .split(" ")
            .map((word) => word[0])
            .slice(0, 2)
            .join("")
            .toUpperCase(); // Extract initials from name
          return (
            <Box display="flex" alignItems="center" gap={1}>
              <Avatar
                sx={{
                  bgcolor: "#1976d2",
                  width: 24,
                  height: 24,
                  fontSize: "0.75rem",
                }}
              >
                {initials}
              </Avatar>
              <span>{params.value}</span>
            </Box>
          );
        }
        // Default fallback
      },
    },
    {
      field: "logHourse",
      headerName: "Daily Log Hours",
      width: 200,
      editable: login_user_role === "CLIENT" ? false : true,
      align: "start",
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              <span>{params.value}</span>
            </Box>
          );
        }
        const logHours = Array.isArray(params.value)
          ? params.value
          : [params.value];
        const getColor = (index) => {
          if (params.row.isSubtask) return "black";
          return index === 0 ? "#00BF00" : index === 1 ? "#34C1FD" : "#FF955A";
        };
        return (
          <Box sx={{ display: "flex", gap: "8px" }}>
            {logHours.map((hour, index) => (
              <Box
                key={index}
                sx={{ color: getColor(index), fontWeight: "bold" }}
              >
                {hour}
              </Box>
            ))}
          </Box>
        );
      },
    },
    {
      field: "Date",
      headerName: "Date",
      width: 150,
      editable: login_user_role === "CLIENT" ? false : true,
      align: "left",
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              {/* edit data */}
              {/* <CustomCalendar /> */}
              <span>{params.value}</span>
            </Box>
          );
        }
        return null;
      },
    },
    {
      field: "timePeriod",
      headerName: "Time Period",
      width: 180,
      align: "left",
      editable: false,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              {/* edit data */}
              <span>{params.value}</span>
            </Box>
          );
        }
        return null;
      },
    },

    {
      field: "dashBoard",
      headerName: "Notes",
      width: 150,
      align: "left",
      editable: login_user_role === "CLIENT" ? false : true,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <div
              // className=" d-flex align-items-center justify-content-center w-100 h-100 "
              onClick={() => handleDashboardClick(params.row)} // Entire cell clickable
            >
              {params.value || "Edit Notes"}
            </div>
          );
        }
        return null; // Return null for non-subtasks
      },
    },
    {
      field: "billingType",
      headerName: "Status",
      align: "left",
      width: 200,
      editable: false,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box mt={2}>
              {/* edit data */}
              <Typography
                sx={{
                  color: params.value === "BILLABLE" ? "#34C1FD" : "#FF955A",
                }}
              >
                {params.value}
              </Typography>
            </Box>
          );
        }
        return null; // Return null for non-subtasks
      },
    },
    {
      field: "timesheet_type",
      headerName: "Type",
      width: 100,
      editable: false,
      // renderCell: (params) => {
    },
    {
      field: "added_name",
      headerName: "Added By",
      width: 200,
      editable: false,
      // renderCell: (params) => {
    },
    {
      field: "reported_manager_name",
      headerName: "Report To",
      width: 200,
      editable: false,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          const value = params.value;
          if (!value || value.toLowerCase?.() === "none") {
            return "------------";
          }
          return value;
        }
        return null;
      },
    },
    {
      field: "approval_status",
      headerName: "OT Status ",
      width: 200,
      editable: false,
    },
  ];

  const handleCloseProject = () => {
    setShowProject(false);
  };
  return (
    <>
      <Offcanvas show={showProject} placement="end" style={{ width: "50%" }}>
        <Offcanvas.Body className="p-0">
          {/* <AddSubTaskLogHoursComponent
            onApply={(filters) => setShowProject(false)}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
          /> */}
          <CommonAddLogHours
            onApply={handleCloseProject}
            onClear={() => reset()}
            onCancel={handleCloseProject}
            span={"today"}
            fromDate={fromDate}
            toDate={toDate}
            // refetchList={refetch}
              refetchList={() => {
              refetch();
              if (parentRefetch) {
                parentRefetch();
              }
            }}
            isModule={false}
            isDetail={true}
            TaskOrIssueId={id}
            isTaskOrIssue="task"
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        show={showFilter}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <FilterTaskLogHoursComponent
            onApply={handleApplyFilter}
            onClear={handleClearFilter}
            onCancel={() => setShowFilter(false)}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <Offcanvas show={showExportPage} placement="end" style={{ width: "50%" }}>
        <OffcanvasBody>
          {/* <ExportComponent
            onApply={hadleExport}
            onCancel={() => setShowExportPage(false)}
          /> */}
          <CommonExportComponent
            onApply={hadleExport}
            // view_type={filter}
            onCancel={() => setShowExportPage(false)}
            isModule={false}
            isTask={true}
          />
        </OffcanvasBody>
      </Offcanvas>

      <div style={{ padding: "16px", backgroundColor: isDarkMode ? "transparent" : undefined }} className={isDarkMode ? "" : "bg-white"}>
        <Box style={{ width: "100%", backgroundColor: "transparent" }}>
          <Box
            className="d-flex justify-content-end align-items-center gap-2"
            sx={{
              border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
              borderRadius: "6px",
              padding: "12px 16px",
              marginTop: "-5px",
              marginBottom: "12px",
              backgroundColor: isDarkMode ? "transparent" : "#fff",
            }}
          >
            {login_user_role !== "CLIENT" && (
              <button className="add_btn" onClick={handleShowProject}>
                Add Log Hours
              </button>
            )}
              {/* <button
                className="text-decoration-none border-0 rounded-circle project-icon-bg p-2"
                onClick={handleShowFilter}
              >
                <CiFilter className="text-rgbr-blue pro-icon-s" />
              </button> */}
            {login_user_role !== "EMPLOYEE" && (
              <Tooltip title="Export timelog">
                <IconButton
                  onClick={handleExportPage}
                  sx={{
                    backgroundColor: isDarkMode ? "rgba(67, 105, 255, 0.08)" : "#F1F5FF",
                    borderRadius: "50%",
                    padding: "6px",
                    "&:hover": {
                      backgroundColor: isDarkMode ? "rgba(67, 105, 255, 0.2)" : "#e0e7ff",
                    },
                  }}
                >
                  <CiExport className="text-rgbr-blue pro-icon-s" />
                </IconButton>
              </Tooltip>
            )}
          </Box>

          {/* <Box
            sx={{
              height: data?.length === 0 ? 300 : "auto",
            }}
          > */}
          {/* <div className=" h-auto"> */}

          <div className=" tableScroll">
            <DataGrid
              rows={getFlattenedRows()}
              columns={columns}
              getRowId={(row) => row.id}
              hideFooter
              disableSelectionOnClick
              // autoHeight
              // sx={{
              //   // minHeight: "450px", // Ensures enough space for rows
              //   "& .MuiDataGrid-footerContainer": {
              //     marginTop: "10px",
              //   },
              // }}
              // autoHeight
              // slots={{ noRowsOverlay: CustomNoRowsOverlay }}
              // processRowUpdate={(newRow) => {
              //   if (login_user_role === "CLIENT") {
              //     return;
              //   }
              //   // //console.log()("newRowwwwwwwww:", newRow);

              //   handleRowEdit(newRow); // Update only subtasks
              //   return newRow; // Required for DataGrid to finalize the row update
              // }}
              processRowUpdate={(updatedRow, originalRow) => {
                if (!originalRow.isSubtask) {
                  console.warn("Row_editing_blocked.");
                  toast.error("Only subtasks can be edited.");
                  return originalRow; // Prevent update
                }
                handleRowEdit(updatedRow);
                return updatedRow;
              }}
            />
          </div>
          
          {/* </div>
          </Box> */}
          <Modal open={showQuillPopup} onClose={() => setShowQuillPopup(false)}>
            <Box
              className="bg-white"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 600,
                maxWidth: 500,
                height: 300,
                // bgcolor: "background.paper",
                boxShadow: 10,
                p: 2,
              }}
            >
              <ReactQuill
                theme="snow"
                value={quillContent}
                onChange={(content) => setQuillContent(content)} // Update state
                style={{ height: "150px", marginBottom: "20px" }}
              />
              <Box
                display="flex"
                marginTop={10}
                justifyContent="flex-end"
                gap={2}
              >
                <button
                  className="cancel_btn"
                  onClick={() => setShowQuillPopup(false)}
                >
                  Cancel
                </button>
                <button className="add_btn" onClick={handleDashboardSave}>
                  Save
                </button>
              </Box>
            </Box>
          </Modal>

          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => handleViewDetail("View")}>
              <CiViewList className="me-2" color="blue" />
              View Details
            </MenuItem>
            <MenuItem
              onClick={() => handleViewDetailNewPage("View in New Tab")}
            >
              <CiViewList className="me-2" color="blue" />
              View Details in New Tab
            </MenuItem>
            {/* <MenuItem onClick={() => handleMenuAction("Copy Link")}>
              Copy Link
            </MenuItem> */}
            {/* <MenuItem onClick={() => handleMenuAction("Clone")}>Clone</MenuItem> */}
            
            {login_user_role !== "CLIENT" && (
              <CommonDeleteDialog
                name="Timelog"
                id={selectedTask?.id}
                url={"timesheet/delete"}
                // refetchList={refetch}
                  refetchList={() => {
                  refetch();
                  if (parentRefetch) {
                    parentRefetch();
                  }
                }}
                statusName={selectedTask?.name}
                handleListClose={handleMenuClose}
              />
              // <Delete
            )}
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default TaskLogHours;
